<div class="banner-wrapper">
    <div class="content-wrapper">
        <ms-promotion-status-button-wrapper
            [promotion]="promotion"
            (detailsPopupChange)="getDetailsPopupChange($event)"
            (optInButtonClicked)="optInButtonClicked()" />
    </div>
</div>
@if (promotion.banner?.keyTerms) {
    <div class="terms" [innerHtml]="promotion.banner?.keyTerms"></div>
}
